<template>
  <div class="list-move" :id="isDetail ? 'list-move-specail' : 'list-move'">
    <div
      :class="target ? 'listmovesearch-value-specail': 'listmovesearch-value'"
      :style="isDetail ? {'width': '340px'} : ''"
      @click="createdListHandle"
      v-if="listData.length === 0"
    >{{createName}}</div>
    <Dropdown trigger="custom" :visible="visible">
      <a href="javascript:void(0)" @click="handleOpen">
        <span class="nx-content">{{listChangeName}}</span>
        <Icon type="arrow-down-b"></Icon>
      </a>
      <Dropdown-menu slot="list">
        <li
          v-if="listData.length > 0"
          :key="index"
          class="custom-li"
          :class="listChangeId === item.id ? 'custom-li-specail': ''"
          v-for="(item, index) in listData"
          @click="getValueList(item)"
        >{{item.name}}</li>
      </Dropdown-menu>
      <div
        class="input-search"
        :style="isDetail ? {'width': '340px'} : ''"
        :class="target ? 'input-search-specail' : ''"
        v-if="visible"
      >
        <input
          maxlength="15"
          type="text"
          placeholder="快速查找／创建新的清单"
          @input="changeInputHandle()"
          @keyup.enter="setInputHandle"
          v-model="filter.name"
        >
      </div>
    </Dropdown>
  </div>
</template>
<script>
import api from "../../api";
export default {
  data() {
    return {
      listData: [],
      choicedList: "",
      filter: {
        id: this.$route.query.id || "",
        name: ""
      },
      listChangeId: null,
      listChangeName: "请选择清单…",
      visible: false,
      createName: "创建清单"
    };
  },
  props: {
    target: {
      type: Boolean,
      defalut: false
    },
    isDetail: {
      type: Boolean,
      defalut: false
    },
    sureOrderHandle: {
      type: Boolean,
      defalut: true
    }
  },
  components: {},
  methods: {
    createdListHandle() {
      this.setInputHandle();
    },
    listAjax(target = false) {
      this.visible = target;
      // this.visible = true;
      api.detailedLists.name_list_search(this.filter).then(res => {
        if (res) {
          this.listData = res;
          if (res.length === 0) {
            this.visible = true;
          } else {
            if (target) {
              this.visible = true;
            } else {
              this.visible = false;
            }
          }
        }
      });
    },
    handleOpen() {
      this.visible = !this.visible;
    },
    changeInputHandle() {
      this.listAjax(true);
    },
    getValueList(item) {
      item
        ? (this.listChangeName = item.name)
        : (this.listChangeName = "请选择清单…");
      this.listChangeId = item.id;
      this.visible = false;
      this.$emit("getId", this.listChangeId);
      this.$emit("getChoicedListHandle", this.listChangeId);
    },
    setInputHandle() {
      if (!this.filter.name) {
        this.$Message.error("请填写输入内容！");
        return false;
      } else {
        if (this.listData.length > 0) {
          this.listAjax();
        } else {
          //创建
          api.detailedLists
            .createDetailedList({
              name: this.filter.name
            })
            .then(res => {
              this.listData.push(res);
              res
                ? (this.listChangeName = res.name)
                : (this.listChangeName = "请选择清单…");
              this.listChangeId = res.id;
              this.filter.name = "";
              this.$emit("getTargetListId", this.listChangeId);
              this.$emit("getId", this.listChangeId);
              this.$emit("getChoicedListHandle", this.listChangeId);
              this.listAjax();
              this.$Message.success("创建清单成功");
            });
        }
      }
    }
  },
  created() {
    this.listAjax();
  },
  watch: {
    "filter.name": function() {
      this.filter.name
        ? (this.createName = "创建清单" + ' " ' + this.filter.name + ' " ')
        : (this.createName = "创建清单");
    },
    sureOrder: function() {
      this.visible = false;
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.list-move {
  margin-top: 45px;
  padding-bottom: 36px;
  /*height: 248px;*/
  .listmovesearch-value {
    cursor: pointer;
    width: 566px;
    height: 40px;
    line-height: 30px;
    text-align: left;
    padding: 0 18px;
    font-size: 16px;
    color: #fff;
    position: absolute;
    background: #e14b5d;
    z-index: 600;
    left: 87px;
  }
  .listmovesearch-value-specail {
    cursor: pointer;
    width: 566px;
    height: 40px;
    line-height: 30px;
    text-align: left;
    padding: 0 18px;
    font-size: 16px;
    color: #fff;
    position: absolute;
    background: #e14b5d;
    z-index: 600;
  }
  .input-search {
    width: 100%;
    padding: 10px 16px;
    background: #a2a2a8;
    position: fixed;
    width: 565px;
    margin-left: -17px;
    margin-top: 154px;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    z-index: 1000;
    transition: opacity 0.5s ease;
    -moz-transition: opacity 0.5s;
    -webkit-transition: opacity 0.5s;
    -o-transition: opacity 0.5s;
    > input {
      width: 100%;
      height: 40px;
      background: #ffffff;
      border-radius: 4px;
      border: none;
      padding: 0 20px;
      font-size: 14px;
      color: #a2a2a8;
    }
  }
  .input-search-specail {
    position: absolute;
    width: 566px;
    margin-left: -18px;
  }
  .trank-list:hover {
    opacity: 0.8;
  }
  .nx-content {
    display: inline-block;
    width: 95%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    line-height: 14px;
  }
}
</style>
<style>
#list-move .ivu-dropdown,
#list-move-specail .ivu-dropdown {
  margin: 0px;
  width: 566px;
  height: 34px;
  line-height: 34px;
  text-align: left;
  padding: 0px 17px;
  border: 1px solid #a2a2a8;
  border-radius: 4px;
}
#list-move-specail .ivu-dropdown {
  width: 340px;
}
#list-move .ivu-dropdown {
  position: relative;
}
#list-move .ivu-dropdown-rel a,
#list-move-specail .ivu-dropdown-rel a {
  display: inline-block;
  width: 100%;
  height: 100%;
}
#list-move .ivu-icon-arrow-down-b,
#list-move-specail .ivu-icon-arrow-down-b {
  float: right;
  margin-top: 11px;
}

#list-move .ivu-select-dropdown,
#list-move-specail .ivu-select-dropdown {
  height: 160px;
  overflow-y: auto;
  margin: 0px;
  box-shadow: none;
  border: 1px solid #a2a2a8;
  margin-top: -4px;
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
  border-top: none;
  /*left: 87px;*/
  left: -1px !important;
  /*top: 170px;*/
  margin-left: 0px;
  transform-origin: center top 0px;
}
#list-move-specail .ivu-select-dropdown {
  margin-top: -5px;
  margin-left: -2px;
  left: 22px !important;
  top: 228px;
}
/*228*/
#list-move .ivu-select-dropdown li,
#list-move-specail .ivu-select-dropdown li {
  font-size: 14px;
  color: #353838;
  padding: 0 18px;
  cursor: pointer;
  width: 320px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
#list-move .ivu-select-dropdown li:hover,
#list-move-specail .ivu-select-dropdown li:hover {
  background: #308697;
  color: #ffffff;
}
#list-move .ivu-select-dropdown li.custom-li-specail,
#list-move-specail .ivu-select-dropdown li.custom-li-specail {
  background: #308697;
  color: #ffffff;
}
</style>